import React from 'react';

function ArtworkTab() {
	return <div />;
}

export default ArtworkTab;
